import { Environment, getEnvironment } from './Environment';
import LOCAL from './environment.local';
import TEST from './environment.test';
export const getAppConfiguration = () => {
    let env = {};
    if (getEnvironment() === Environment.TEST) {
        env = TEST;
    }
    else if (getEnvironment() === Environment.LOCAL) {
        env = LOCAL;
    }
    return Object.assign({}, env);
};
export const getAppRoutes = () => {
    return getAppConfiguration().routes;
};
